import { MEDIA_CATEGORY, MEDIA_SUB_SUB_CATEGORY, NAME } from '../../fields'

export const getInitialValues = ({ subCategoryData }) => ({
  [NAME]: subCategoryData?.[NAME] || '',
  [MEDIA_CATEGORY]: subCategoryData?.[MEDIA_CATEGORY] || '',
  [MEDIA_SUB_SUB_CATEGORY]: subCategoryData?.[MEDIA_SUB_SUB_CATEGORY] || []
})
